import '@/presentation/assets/styles/global-scrollbar.css'
import '@/presentation/assets/styles/index.css'
import '@/presentation/assets/styles/accessibility.css'
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import './i18n'
import ErrorMonitor from './infra/tracking/error-monitor'
import { launchDarklyConfig } from './infra/feature-flag'
import Router from './main/routes/router'

ErrorMonitor.startMonitoring()

const renderApp = async () => {
  // Antes de qualquer request: registrar o service worker primeiro elimina a
  // corrida em que a primeira chamada escapa sem interceptação.
  // `import.meta.env.DEV` vira o literal `false` no build de produção, então o
  // Rollup elimina o bloco inteiro — o msw não entra no bundle. Ler isso de
  // `settings.ts` quebraria o tree-shaking (acesso a propriedade em runtime).
  if (import.meta.env.DEV && import.meta.env.VITE_ENABLE_API_MOCKS === 'true') {
    const { enableApiMocks } = await import('./mocks')
    await enableApiMocks()
  }

  const LDProvider = await asyncWithLDProvider(launchDarklyConfig)

  const root = ReactDOM.createRoot(document.getElementById('root')!)

  root.render(
    <StrictMode>
      <LDProvider>
        <Router />
      </LDProvider>
    </StrictMode>
  )
}

renderApp()
